import { DisplayText, Row } from "components/lib";
import styled from "@emotion/styled";
import { getLanguage, languageKey } from "auth-provider";
import { useEffect, useState } from "react";
import {
  MIX_PANEL_EVENT,
  trackMixPanel,
  useTrackCommonData,
} from "mixpanel/mixpanelTrackUtil";
import order from "assets/order.png";
import { getErrorMsg } from "utils/http";
import { getCookie, removeCookie, StorageMobile } from "./util";
import { useAuth } from "context/auth-context";
import { slicePhoneNumber } from "utils";
import { useUrlQueryParam } from "utils/url";
import { useLoyaltyMemberService } from "hook/useLoyaltyMemberServiceHook";
import { AccessTokenQueryKey } from "utils/oauth";
import { useSearchParams } from "react-router-dom";

const RightLabelMap = {
  en: "中",
  zh: "EN",
};

const styleObj = {
  right: { width: "8rem" },
  noLangSwitchRight: { width: "4rem" },
};

export type LabelType = keyof typeof RightLabelMap;

export const PageHeader = ({ showLangSwicth = true, ...props }) => {
  const [searchParams] = useSearchParams();
  const onboardingForTwilio = searchParams.get('onboarding') === 'true' ? true : false;
  const fromSmartOrdering = searchParams.get('source') === 'smart_ordering' ? true : false;
  const [language, setLanguage] = useState(getLanguage());
  const trackCommonData = useTrackCommonData();
  const { toggleLang } = useLoyaltyMemberService();
  const [{ source }] = useUrlQueryParam(["source"]);
  const { restaurant: restaurantData } = useAuth();
  const [enableShowLangSwicth, setEnableShowLangSwicth] = useState(showLangSwicth);

  // eslint-disable-next-line
  const changeLanguage = (specLanguage?: LabelType) => {
    let targetLanguage = language === "en" ? "zh" : "en" as LabelType
    if (specLanguage) {
      targetLanguage = specLanguage;
    }
    // const targetLanguage = language === "en" ? "zh" : "en";
    setLanguage(targetLanguage);
    props?.changeLang?.(targetLanguage);
    checkAndSetCookie();
    window.localStorage.setItem(languageKey, targetLanguage);
    trackMixPanel(MIX_PANEL_EVENT.HOME_PAGE_SWITCH_LANGUAGE, trackCommonData);
    saveLanguage(targetLanguage);
  };


  const saveLanguage = (lang: LabelType) => {
    const phone_number = StorageMobile("get");
    const restaurant_id = restaurantData?.data?.id;
    const tokenObjStr = localStorage.getItem(AccessTokenQueryKey);
    if (!phone_number || !restaurant_id || !tokenObjStr) {
      return;
    }
    toggleLang(lang, phone_number)
      .then((data) => {
        if (data) {
          trackMixPanel(
            MIX_PANEL_EVENT.HOME_PAGE_SWITCH_LANGUAGE_SUCCESS,
            trackCommonData
          );
        }
      })
      .catch((e) => {
        const msg = getErrorMsg(e);
        trackMixPanel(MIX_PANEL_EVENT.HOME_PAGE_SWITCH_LANGUAGE_FAILED, {
          errorApi: "api/{lang}/v1/restaurant_members/toggle_lang",
          restaurant_id,
          errorMsg: msg,
          mNo: slicePhoneNumber(phone_number),
          ...trackCommonData,
        });
      });
  };
  const checkAndSetCookie = () => {
    if (source === "smart_ordering") {
      const cookieLang = getCookie("lang");
      if (cookieLang === "en" || cookieLang === "zh") {
        removeCookie("lang");
      }
    }
  };


  useEffect(() => {
    if (restaurantData && !restaurantData.isEnableLanguageSwitch) {
      props?.changeLang?.('en');
      checkAndSetCookie();
      setLanguage('en');
      setEnableShowLangSwicth(false);
      saveLanguage('en');
    }
    // eslint-disable-next-line
  }, [restaurantData, props]);

  return (
    <HeaderWrapper style={props?.styleObj} between={true}>
      {props?.children}
      {props.isResaurant ? (
        <DisplayText justCon={"space-between"} style={enableShowLangSwicth && !onboardingForTwilio && !fromSmartOrdering ? styleObj.right : styleObj.noLangSwitchRight}>
          <CircleText onClick={props?.showOrderHistory}>
            <img src={order} alt="img" style={{ width: "1.4rem" }} />
          </CircleText>
          {
            enableShowLangSwicth && !onboardingForTwilio && !fromSmartOrdering && <CircleText onClick={() => changeLanguage()} isZh={language === "zh"}>
              {RightLabelMap[language as LabelType]}
            </CircleText>
          }
        </DisplayText>
      ) : (
        <> {
          enableShowLangSwicth && !onboardingForTwilio && !fromSmartOrdering && <CircleText onClick={() => changeLanguage()} isZh={language === "zh"}>
            {RightLabelMap[language as LabelType]}
          </CircleText>
        }
        </>
      )}
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled(Row)`
  padding: 1rem 1.6rem;
  border-bottom: 0.5px solid rgba(237, 214, 180, 0.3);
`;

const CircleText = styled.div<{
  isZh?: boolean;
}>`
  width: 3.6rem;
  height: 3.6rem;
  line-height: ${(props) => (props.isZh ? "3.6rem" : "3.85rem")};
  text-align: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  color: #edd6b4;
  font-size: 1.4rem;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
`;
